import { defineComponent as _defineComponent } from 'vue'
import router from "@/router";
import InlineSvg from "vue-inline-svg";


const __default__ = {
  name: "NavigationBar",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  overrideOnClickBack: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: "",
  },
  shouldHideBackButton: {
    type: Boolean,
    default: false,
  },
  shouldShowUnderline: {
    type: Boolean,
    default: false,
  },
  shouldHideCloseButton: {
    type: Boolean,
    default: false,
  },
},
  emits: ["onClickClose", "onClickBack"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const onClickBack = () => {
  router.currentRoute.value.meta.willGoBack = true;
  if (props.overrideOnClickBack) {
    emit("onClickBack");
    return;
  }
  router.back();
};

const __returned__ = { props, emit, onClickBack, get InlineSvg() { return InlineSvg } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})